var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboStopCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.136 1 1 4.143 1 8C1 11.857 4.136 15 8 15C11.864 15 15 11.857 15 8C15 4.143 11.857 1 8 1ZM8 2.218C11.185 2.218 13.782 4.808 13.782 8C13.782 9.358 13.306 10.611 12.515 11.598L4.402 3.485C5.389 2.694 6.642 2.218 8 2.218ZM8 13.782C4.808 13.782 2.218 11.185 2.218 8C2.218 6.677 2.659 5.452 3.415 4.479L11.521 12.585C10.548 13.334 9.323 13.782 8 13.782Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboStopCircleSmall);
export default __webpack_public_path__ + "static/media/FBOStopCircleSmall.ab4194fa4beb112862e31beb4450b925.svg";
export { ForwardRef as ReactComponent };